module.exports = __webpack_public_path__ + "img/IMG-20191106-WA0063.121d639d.jpg";